import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";

// icons
import ActionPrint from "@material-ui/icons/Print";
import ActionCheck from "@material-ui/icons/Check";
import ActionReject from "@material-ui/icons/CancelOutlined";
import ActionSend from "@material-ui/icons/Send";
import ActionSkip from "@material-ui/icons/Redo";
import MarryIcon from "mdi-material-ui/Tune";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Button, BackButton, showNotification } from "jazasoft";
import { AlertParemeter, OState, TaskNames } from "../../../utils/types";
import hasPrivilege from "../../../utils/hasPrivilege";
import { getDistinctValues, isEmpty, isTrue } from "../../../utils/helpers";
import { findSizeBreakupList, getCutOrderFlowInfoList, getPartType } from "../../../helpers/orderHelper";
import useMutation from "../../../hooks/useMutation";
import useSafeState from "../../../hooks/useSafeState";
import DialogNames from "./dialog/DialogNames";
import CutPlanApprovalDialog from "./dialog/CutPlanApprovalDialog";
import useQuery from "../../../hooks/useQuery";
import useDeepMemo from "../../../hooks/useDeepMemo";
import { CutPlanActions, MULTI_PART_MANUAL_PLAN, PART_SHELL } from "../../../constants";
import { UPDATE_TASK } from "../../../reducers/scheduledTaskReducer";
import { printCutPlan } from "../cutPlanHelper";
import useTenant from "../../../hooks/useTenant";
import { ResourceId, Scope } from "../../../utils/privilege";
import { useSetting } from "../../../hooks";
import SettingKeys from "../../../utils/SettingKeys";

// Logic for Showing MarryCutPlan Button
// For Separate Cut Plan: if State Full Plan is Completed for all flows and planned qty is not same (size by size)
// For Replicate Cut Plan: if State Full Plan is Completed for all flows and planned qty is not same (size by size)
// For Manual Cut Plan: Do not show marry button

const useStyles = makeStyles({
  footer: {
    padding: "1.5em 0"
  },
  button: {
    margin: "0 0.5em"
  }
});

const Footer = props => {
  const classes = useStyles();
  const {
    version,
    order,
    cutOrder,
    uom,
    cutOrderList,
    ledgerList,
    rollInfoList,
    planTabIdx,
    scheduledTasks = {},
    orderFields,
    roles,
    hasAccess,
    hasPermission,
    onRefresh,
    fabricPatternList,
    unitList = []
  } = props;
  const cutPlanGenerated = cutOrder?.stateValue > OState.MAIN_CUTPLAN_GENERATED.stateValue;
  const flowInfoList = getCutOrderFlowInfoList(order, cutOrder);
  const tenant = useTenant();
  const [dialogState, setDialogState] = useSafeState({ active: false, name: null, action: null, alerts: [] });

  const enableMarkerPerimeterUpdate = useSetting(SettingKeys.ENABLE_MARKER_PERIMETER_UPDATE);
  const enablePerimeterUpdate = isTrue(enableMarkerPerimeterUpdate);

  const { data: logList = [] } = useQuery(!isEmpty(order?.id) && { url: `logs`, params: { orderId: order?.id }, version });
  // const { data: alertReasonList = [] } = useQuery({ url: "alertReasons", params: { size: 1000 } });
  const alertReasonList = [];
  const { data: alertParameterList = [] } = useQuery({ url: "alert-parameters", params: { size: 1000 } });
  // const [download, { loading: busy }] = useMutation({ rawResponse: true });
  const [update, { loading: updating }] = useMutation();
  const dispatch = useDispatch();
  const i18nMessages = useSelector(state => state?.i18n?.messages || {});
  const busy = false;

  const cutPlanAnalysisCompleted = cutOrder?.orderConfig?.cutPlanAnalysisCompleted || false;

  const onPrint = () => {
    const unit = unitList.find(e => e.unitId === cutOrder?.unitId) || {};
    printCutPlan(
      order,
      cutOrder,
      uom,
      planTabIdx,
      rollInfoList,
      ledgerList,
      logList,
      orderFields,
      i18nMessages,
      tenant,
      fabricPatternList,
      unit,
      alertParameterList,
      enablePerimeterUpdate
    );
  };

  // const onDownload = () => {
  //   alert("Not Implemented yet. Will be implemented very soon");
  //   return;

  //   // const options = {
  //   //   url: `orders/${order?.id}/markers`,
  //   //   method: "get",
  //   //   responseType: "arraybuffer",
  //   //   params: {
  //   //     action: "download",
  //   //     flowId: orderFlow?.id,
  //   //     stage: planTabIdx
  //   //   }
  //   // };

  //   // download(options, {
  //   //   onSuccess: response => {
  //   //     const header = response.headers["content-disposition"];
  //   //     var filename = header ? header.match(/filename="(.+)"/)[1] : "CUTPLAN.xlsx";
  //   //     let blob = new Blob([response.data], {
  //   //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //   //     });
  //   //     let link = document.createElement("a");
  //   //     link.href = window.URL.createObjectURL(blob);
  //   //     link.download = filename;
  //   //     link.click();
  //   //   }
  //   // });
  // };

  // const onApprovalClick = action => {
  //   let alerts = {};

  //   // Check Cut Percent Alert
  //   if (order && cutOrder) {
  //     // const orderQty = findSizeBreakupList(cutOrder, order).reduce((acc, sb) => acc + sb.qty, 0);
  //     const flowInfoList = getCutOrderFlowInfoList(order, cutOrder);
  //     const sizeBreakupList = flowInfoList.flatMap(fi => fi.sizeBreakupList).filter(sb => sb.type === "ORDER");
  //     const orderQty = sizeBreakupList.reduce((acc, sb) => acc + sb.qty, 0);
  //     const approvedQtyMap = JSON.parse(cutOrder.orderConfig.approvedOrderCutQty);

  //     let cutQty = Object.keys(approvedQtyMap)
  //       .flatMap(styleColor => Object.keys(approvedQtyMap[styleColor]).map(size => approvedQtyMap[styleColor][size]))
  //       .reduce((acc, qty) => acc + qty, 0);

  //     //* Cut Qty in previous lots **//
  //     const prevLotState = mapFromCsv(cutOrder.prevLotState, ";");
  //     const lotValues = Object.keys(prevLotState);
  //     const prevFlowList = order.orderFlowList
  //       .filter(
  //         of =>
  //           of.type === OrderFlowType.CUTPLAN &&
  //           cutOrder.productIdList?.every(id => of.productIdList?.includes(id)) &&
  //           of.styles === cutOrder.styles &&
  //           of.colors === cutOrder.colors
  //       )
  //       .filter(of => of.part === cutOrder.part && lotValues.includes(of.lotValue))
  //       .filter(of => isEmpty(cutOrder.inseams) || cutOrder.inseams === of.inseams)
  //       .filter(of => isEmpty(cutOrder.destinations) || cutOrder.destinations === of.destinations)
  //       .filter(of => isEmpty(cutOrder.deliveries) || cutOrder.deliveries === of.deliveries)
  //       .filter(of => isEmpty(cutOrder.delModes) || cutOrder.delModes === of.delModes)
  //       .filter(of => isEmpty(cutOrder.flowRefs) || cutOrder.flowRefs === of.flowRefs)
  //       .filter(of => isEmpty(cutOrder.customerFlowRefs) || cutOrder.customerFlowRefs === of.customerFlowRefs);
  //     prevFlowList.forEach(flow => {
  //       const approvedQtyMap = JSON.parse(flow.orderConfig.approvedOrderCutQty);
  //       cutQty += Object.keys(approvedQtyMap)
  //         .flatMap(styleColor => Object.keys(approvedQtyMap[styleColor]).map(size => approvedQtyMap[styleColor][size]))
  //         .reduce((acc, qty) => acc + qty, 0);
  //     });

  //     if (cutQty < orderQty) {
  //       alerts.lowCutPercent = true;
  //     }
  //   }
  //   // Check Consumption variation Alert
  //   if (order && cutOrder && order.flowInfoList) {
  //     const styleColorList = cutOrder.styleColorList;
  //     const fabricUsageList = JSON.parse(cutOrder.orderConfig.fabricUsageInfo);
  //     styleColorList.forEach(styleColor => {
  //       const flowInfo = getCutOrderFlowInfoList(order, cutOrder).find(fi => fi.styleColor === styleColor);
  //       const bomCuList = JSON.parse(cutOrder?.bomCu || "[]");
  //       const bomCu = bomCuList?.find(e => getStyleColor(e.style, e.color) === styleColor)?.bomCu;
  //       const fabricUsage = fabricUsageList.find(e => getStyleColor(e.style, e.color) === styleColor && e.uom === UOM.METER.value);
  //       if (flowInfo && fabricUsage) {
  //         if (
  //           (fabricUsage.actualCu > bomCu && (fabricUsage.actualCu - bomCu) * 100 > cuIncrease) ||
  //           (fabricUsage.actualCu < bomCu && (bomCu - fabricUsage.actualCu) * 100 > cuDecrease)
  //         ) {
  //           alerts.consumptionVariation = true;
  //         }
  //       }
  //     });
  //   }
  //   // Check Marker Efficiency Alert
  //   if (order && cutOrder && order.flowInfoList && cutOrder.markerList) {
  //     const effMap = cutOrder.markerList
  //       .filter(m => m.efficiency)
  //       .map(m => ({
  //         key: m.efficiency,
  //         weight: m.noOfWays * m.markerPlyList.reduce((acc, mp) => acc + mp.plannedPlies, 0)
  //       }));
  //     const weightedEfficiecny = getWeightedMean(effMap);

  //     const styleColorList = cutOrder.styleColorList;
  //     styleColorList.forEach(styleColor => {
  //       const [style, color] = styleColor.split(DEFAULT_SEPARATOR);
  //       const ledger = ledgerList?.find(
  //         l => cutOrder.productIdList?.includes(l.productId) && l.style === style && l.styleColor === color && l.part === cutOrder.part
  //       );
  //       if (!isEmpty(ledger?.fabric)) {
  //         const fabric = ledger?.fabric;

  //         if (fabric && !isEmpty(lowMarkerEffMap)) {
  //           if (fabric.repeatLength && fabric.repeatWidth) {
  //             const repeatValues = lowMarkerEffMap["2DRepeat"];
  //             const key = Object.keys(repeatValues).find(key => {
  //               const start = parseInt(key.split("-")[0]);
  //               const end = parseInt(key.split("-")[1]);
  //               const repeat = fabric.repeatLength * fabric.repeatWidth;
  //               return repeat >= start && repeat < end;
  //             });
  //             if (weightedEfficiecny < repeatValues[key]) {
  //               alerts.lowMarkerEfficiency = true;
  //             }
  //           } else if (fabric.repeatLength || fabric.repeatWidth) {
  //             const repeatValues = lowMarkerEffMap["1DRepeat"];
  //             const key = Object.keys(repeatValues).find(key => {
  //               const start = parseInt(key.split("-")[0]);
  //               const end = parseInt(key.split("-")[1]);
  //               const repeat = fabric.repeatLength || fabric.repeatWidth;
  //               return repeat >= start && repeat < end;
  //             });
  //             if (weightedEfficiecny < repeatValues[key]) {
  //               alerts.lowMarkerEfficiency = true;
  //             }
  //           } else {
  //             const repeatValues = lowMarkerEffMap["NoRepeat"];
  //             if (cutOrder.orderConfig.csv && weightedEfficiecny < repeatValues["CSV"]) {
  //               alerts.lowMarkerEfficiency = true;
  //             } else if (!cutOrder.orderConfig.csv && weightedEfficiecny < repeatValues["Normal"]) {
  //               alerts.lowMarkerEfficiency = true;
  //             }
  //           }
  //         }
  //       }
  //     });
  //   }

  //   setDialogState({ active: true, name: DialogNames.CUT_PLAN_APPROVAL, action, alerts });
  // };

  const onApprovalSubmit = values => {
    let { cadRemarks, merchantRemarks } = values;
    const alertKeys = Object.values(AlertParemeter).map(e => e.id);
    const alerts = Object.keys(values)
      .filter(key => alertKeys.includes(key))
      .reduce((acc, key) => ({ ...acc, [key]: values[key] }), {});

    //validations
    let error;
    let keys = Object.keys(alerts);
    if (keys.filter(key => !alerts[key] || alerts[key].length === 0).length > 0) {
      error = "Reason for each Parameter is required.";
      dispatch(showNotification(error, { type: "danger", placement: "tc" }));
      return;
    }
    if (dialogState.action === "skip" && !cadRemarks) {
      error = "Remarks is required if you are skipping the approval";
    } else if (keys.flatMap(key => alerts[key]).includes("Others")) {
      if (dialogState.action === "approve" && alerts["lowCutPercent"] && alerts["lowCutPercent"].includes("Others") && !merchantRemarks) {
        error = "Remarks is required if 'Others' reason is selected.";
      } else if (dialogState.action === "send_for_approval" && !cadRemarks) {
        error = "Remarks is required if 'Others' reason is selected.";
      }
    }
    if (error) {
      dispatch(showNotification(error, { type: "danger", placement: "tc" }));
      return;
    }

    const options = {
      url: `orders/${order?.id}/markers/approval`,
      method: "put",
      params: {
        action: dialogState.action,
        flowId: cutOrder.id
      },
      data: {
        cadRemarks,
        merchantRemarks,
        alerts: JSON.stringify(alerts)
      }
    };
    update(options, {
      onSuccess: () => {
        dispatch(
          showNotification(
            dialogState.action === "approve"
              ? "Cut Plan approved successfully."
              : dialogState.action === "skip"
                ? "Cut Plan approval skipped successfully."
                : dialogState.action === "reject"
                  ? "Cut Plan rejected successfully"
                  : "Cut Plan sent for approval"
          )
        );
        setDialogState({ active: false, name: null, action: dialogState.action });
        onRefresh && onRefresh();
      }
    });
  };

  const onNewApprovalSubmit = action => {
    if (action === "send_for_approval") {
      if (!cutPlanAnalysisCompleted) {
        dispatch(
          showNotification(`Variance Analysis is not completed. Hint: Complete Variance Analysis before sending for approval`, { type: "danger" })
        );
        return;
      }
    }

    const options = {
      url: `orders/${order?.id}/markers/approval`,
      method: "put",
      params: {
        action: action,
        flowId: cutOrder.id
      },
      data: {}
    };
    update(options, {
      onSuccess: () => {
        dispatch(
          showNotification(
            action === "approve"
              ? "Cut Plan approved successfully."
              : action === "skip"
                ? "Cut Plan approval skipped successfully."
                : action === "reject"
                  ? "Cut Plan rejected successfully"
                  : "Cut Plan sent for approval"
          )
        );
        onRefresh && onRefresh();
      }
    });
  };

  const onMarryCutPlan = () => {
    // const hasProductRatio = flowInfoList.filter(fi => !isEmpty(fi.productRatio)).length > 1;
    // const productIds = hasProductRatio
    //   ? flowInfoList.filter(fi => !isEmpty(fi.productRatio)).map(fi => fi.product?.id)
    //   : [orderFlow.product?.id];
    // const flowList = order.orderFlowList
    //   ?.filter(
    //     of => of.styles === orderFlow?.styles && of.colors === orderFlow?.colors && productIds.includes(of.product?.id)
    //   )
    //   ?.filter(of => of.stateValue > OState.NEW.stateValue);

    // const flowIds = isEmpty(flowList) ? [orderFlow?.id] : flowList.map(e => e.id);
    const noOfLots = flowInfoList.sort((a, b) => b.lots - a.lots)[0]?.lots || 1;
    const partCount = getDistinctValues(flowInfoList.map(e => e.part)).length;

    const planningDto = {
      // flowIds: flowIds.join(","),
      // flowInfoId,
      cutOrderId: cutOrder?.id,
      poRef: order?.poRef,
      styles: cutOrder?.styles,
      colors: cutOrder?.colors,
      inseams: cutOrder?.inseams,
      destinations: cutOrder?.destinations,
      deliveries: cutOrder?.deliveries,
      flowRefs: cutOrder?.flowRefs,
      customerFlowRefs: cutOrder?.customerFlowRefs,
      productName: cutOrder?.product?.name,
      part: cutOrder?.part,
      lot: cutOrder?.lot,
      noOfLots,
      partCount
    };

    const options = {
      url: `orders/${order?.id}/markers`,
      method: "put",
      data: planningDto,
      params: { action: CutPlanActions.MARRY_CUTPLANS, flowId: cutOrder?.id }
    };

    update(options, {
      onSuccess: data => {
        dispatch({ type: UPDATE_TASK, payload: { task: data } });
        dispatch(showNotification("Task queued. you will be notified once completed"));
        onRefresh && onRefresh();
      }
    });
  };

  const showSendSkipApprovalButton =
    (cutOrder?.stateValue === OState.MAIN_CUTPLAN_COMPLETED.stateValue || cutOrder?.stateValue === OState.REMNANT_CUTPLAN_COMPLETED.stateValue) &&
    hasPrivilege(roles, hasAccess, ResourceId.CUT_PLAN_APPROVAL, Scope.UPDATE, "send_for_approval") &&
    (isEmpty(cutOrder?.orderConfig?.cutPlanApproval) || cutOrder?.orderConfig?.cutPlanApproval === "Rejected");

  const showApproveButton =
    (cutOrder?.stateValue === OState.MAIN_CUTPLAN_COMPLETED.stateValue || cutOrder?.stateValue === OState.REMNANT_CUTPLAN_COMPLETED.stateValue) &&
    hasPrivilege(roles, hasAccess, ResourceId.CUT_PLAN_APPROVAL, Scope.UPDATE, "approve") &&
    cutOrder?.orderConfig?.cutPlanApproval === "Sent" &&
    hasPermission("customerId", order?.customerId);

  const showRejectButton =
    (cutOrder?.stateValue === OState.MAIN_CUTPLAN_COMPLETED.stateValue || cutOrder?.stateValue === OState.REMNANT_CUTPLAN_COMPLETED.stateValue) &&
    hasPrivilege(roles, hasAccess, ResourceId.CUT_PLAN_APPROVAL, Scope.UPDATE, "reject") &&
    cutOrder?.orderConfig?.cutPlanApproval === "Sent" &&
    hasPermission("customerId", order?.customerId);

  const showMarryButton = useDeepMemo(() => {
    if (isEmpty(order) || isEmpty(cutOrder) || !hasPrivilege(roles, hasAccess, ResourceId.CUTPLAN, Scope.UPDATE)) return false;

    if (getPartType(cutOrder?.part) !== PART_SHELL) return false;

    let showMarryButton = false;
    const finalCutOrderList = cutOrderList.filter(e => e.orderConfig?.multiPartBundling !== MULTI_PART_MANUAL_PLAN);

    if (finalCutOrderList.length > 1) {
      // check if cut plan is completed for all flows
      let cutPlanCompleted = finalCutOrderList.every(
        flow => flow.stateValue === OState.MAIN_CUTPLAN_COMPLETED.stateValue || flow.stateValue === OState.CUTPLAN_COMPLETED.stateValue
      );

      if (cutPlanCompleted) {
        const styleColorList = cutOrder.styleColorList;

        let approvedCutQtySet = new Set();
        finalCutOrderList.forEach(flow => {
          const flowInfoList = getCutOrderFlowInfoList(order, flow);
          const flowInfo = flowInfoList[0];
          const productRatio = flowInfo?.productRatio || 1;
          const sbList = findSizeBreakupList(flow, order);
          let approvedQtyMap = JSON.parse(flow.orderConfig?.approvedOrderCutQty || "{}");

          const approvedCutQty = styleColorList
            .map(styleColor => {
              const approvedQty = approvedQtyMap[styleColor] || {};
              const plannedQty = sbList
                .sort((a, b) => a.serialNo - b.serialNo)
                .map(sb => `${sb.sizeKey}:${(approvedQty[sb.sizeKey] || 0) / productRatio}`)
                .join(",");
              return `${styleColor}:- ${plannedQty}`;
            })
            .join(";");
          approvedCutQtySet.add(approvedCutQty);
        });

        if (approvedCutQtySet.size > 1) {
          showMarryButton = true;
        }
      }
    }
    return showMarryButton;
  }, [order, cutOrder, cutOrderList, roles]);

  const task = scheduledTasks[cutOrder?.id] || {};
  const marryingCutPlan = task.name === TaskNames.CUT_PLAN_MARRY && ["New", "Waiting", "Running"].includes(task.state);

  return (
    <div className={classes.root}>
      {/**Dialog */}
      <CutPlanApprovalDialog
        open={dialogState.active && dialogState.name === DialogNames.CUT_PLAN_APPROVAL}
        action={dialogState.action}
        orderFlow={cutOrder}
        alerts={dialogState.alerts}
        alertReasons={alertReasonList}
        onSubmit={onApprovalSubmit}
        onClose={() => setDialogState({ active: false, name: null })}
      />

      <div className={classes.footer}>
        <BackButton variant="outlined" color="primary" className={classes.button} style={{ marginRight: "0.5em" }} />
        {cutPlanGenerated && (
          <Button label="Print" variant="outlined" color="primary" disabled={busy || marryingCutPlan} className={classes.button} onClick={onPrint}>
            <ActionPrint />
          </Button>
        )}
        {/* {cutPlanGenerated && (
          <Button
            label="Download"
            variant="outlined"
            color="primary"
            disabled={busy || marryingCutPlan}
            className={classes.button}
            onClick={onDownload}>
            {busy ? <CircularProgress size={16} thickness={2} color="secondary" /> : <ExcelIcon />}
          </Button>
        )} */}
        {showSendSkipApprovalButton && (
          <Button
            className={classes.button}
            label="Send for Approval"
            variant="outlined"
            color="primary"
            disabled={updating || marryingCutPlan}
            onClick={() => onNewApprovalSubmit("send_for_approval")}>
            {updating && dialogState?.action === "send_for_approval" ? (
              <CircularProgress size={16} thickness={2} color="secondary" />
            ) : (
              <ActionSend />
            )}
          </Button>
        )}
        {showSendSkipApprovalButton && (
          <Button
            className={classes.button}
            label="Skip Approval"
            variant="outlined"
            color="primary"
            disabled={updating || marryingCutPlan}
            onClick={() => onNewApprovalSubmit("skip")}>
            {updating && dialogState?.action === "skip" ? <CircularProgress size={16} thickness={2} color="secondary" /> : <ActionSkip />}
          </Button>
        )}
        {showApproveButton && (
          <Button
            className={classes.button}
            label="Approve"
            variant="outlined"
            color="primary"
            disabled={updating || marryingCutPlan}
            onClick={() => onNewApprovalSubmit("approve")}>
            {updating && dialogState?.action === "approve" ? <CircularProgress size={16} thickness={2} color="secondary" /> : <ActionCheck />}
          </Button>
        )}
        {showRejectButton && (
          <Button
            className={classes.button}
            label="Reject"
            variant="outlined"
            color="primary"
            disabled={updating || marryingCutPlan}
            onClick={() => onNewApprovalSubmit("reject")}>
            <ActionCheck />
            {updating && dialogState?.action === "reject" ? <CircularProgress size={16} thickness={2} color="secondary" /> : <ActionReject />}
          </Button>
        )}
        {showMarryButton && (
          <Button
            className={classes.button}
            label="Marry Cut Plan"
            variant="outlined"
            color="primary"
            disabled={updating || marryingCutPlan}
            onClick={onMarryCutPlan}>
            {updating || marryingCutPlan ? <CircularProgress size={16} thickness={2} color="secondary" /> : <MarryIcon />}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Footer;
